import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  PoComboOption,
  PoModalAction,
  PoModalComponent,
  PoModule,
  PoNotificationService,
  PoTableColumn,
} from "@po-ui/ng-components";
import { AreaTecnicaClienteService } from "./areateccliente.service";
import { FormsModule } from "@angular/forms";
import { AreaTecnicaAdminService } from "../areatecadmin/areatecadmin.service";
import { forkJoin, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

@Component({
  selector: "app-ordemcoleta",
  templateUrl: "./areateccliente.component.html",
  styleUrls: ["./areateccliente.component.css"],
  standalone: false,
})
export class AreaTecnicaClienteComponent implements OnInit {
  constructor(
    private areaTecnicaClienteService: AreaTecnicaClienteService,
    private areaTecnicaAdminService: AreaTecnicaAdminService,
    private poNotification: PoNotificationService
  ) { }

  columnsProdutos: Array<PoTableColumn> = [];
  columnsSimilar: Array<PoTableColumn> = [];
  columnsAcervo: Array<PoTableColumn> = [];
  itemsSimilar: Array<any> = [];
  itemsProdutos: Array<any> = [];
  itemsAcervo: Array<any> = [];
  isPecas: boolean = false;
  produtoItems: Array<any> = [];
  segmento: string = '';
  produtoFiltro: string = '';
  optionsProdutos: Array<any> = [];
  
  // Renomeado para ser mais claro: true = mostrando loading, false = não mostrando
  isLoading: boolean = false;

  ngOnInit(): void {
    this.columnsSimilar = this.areaTecnicaClienteService.getSimilarColumns();
    this.columnsProdutos = this.areaTecnicaClienteService.getProdutosColumns();
    this.columnsAcervo = this.areaTecnicaClienteService.getAcervoColumns();
    this.isPecas = sessionStorage.getItem("Segmento") === "PECAS";
    this.segmento = sessionStorage.getItem("Segmento") || '';
    this.getAcervo();
  }

  BuscaProduto(): void {
    if (!this.produtoFiltro || this.produtoFiltro.trim() === '') {
      this.poNotification.warning('Por favor, informe um filtro para buscar produtos.');
      return;
    }

    // Limpa resultados anteriores
    this.produtoItems = [];
    this.itemsSimilar = [];
    
    // Inicia loading
    this.isLoading = true;
    
    // Chama a busca
    this.getOptProdutos(this.segmento, this.produtoFiltro);
  }

  getAcervo(): void {
    this.isLoading = true;
    const items: Array<any> = [];
    
    this.areaTecnicaAdminService.getAcervos(this.segmento).subscribe({
      next: (acervo) => {
        if (Array.isArray(acervo)) {
          for (let item of acervo) {
            items.push({
              id: item.id,
              titulo: item.titulo,
              descricao: item.descricao,
              link: item.link,
            });
          }
        } else {
          console.warn('O serviço getAcervos não retornou um array:', acervo);
          this.poNotification.warning('Formato de dados inesperado ao carregar acervos.');
        }
      },
      error: (err) => {
        console.error('Erro ao carregar acervos:', err);
        this.poNotification.error('Erro ao carregar acervos.');
        this.isLoading = false;
      },
      complete: () => {
        this.itemsAcervo = items;
        this.isLoading = false;
      }
    });
  }

  getOptProdutos(segmento: string, filtro: string): void {
    this.optionsProdutos = [];
    this.isLoading = true;

    this.areaTecnicaClienteService.getProdutos(segmento, filtro).pipe(
      switchMap((produtos) => {
        const itemList: Array<any> = [];
      
        if (Array.isArray(produtos)) {
          for (let produto of produtos) {
            itemList.push({
              codigo: produto.codigo,
              produto: produto.descricao,
              ncm: produto.ncm,
              ean: produto.ean,
            });
          }
        }

        if (this.isPecas) {
          return this.areaTecnicaClienteService.getSimilar(filtro).pipe(
            catchError(err => {
              console.error('Erro ao buscar similares:', err);
              this.poNotification.warning('Erro ao carregar produtos similares.');
              return of([]);
            }),
            switchMap(similares => {
              const similaresList: Array<any> = [];
              
              if (Array.isArray(similares)) {
                for (let sim of similares) {
                  similaresList.push({
                    codigo: sim.codigo,
                    produto: sim.descricao,
                    similar: sim.similar,
                  });
                }
              }
              
              return of({ produtos: itemList, similares: similaresList });
            })
          );
        } else {
          return of({ produtos: itemList, similares: [] });
        }
      }),
      catchError(err => {
        console.error('Erro ao buscar produtos:', err);
        this.poNotification.error('Erro ao carregar produtos.');
        return of({ produtos: [], similares: [] });
      })
    ).subscribe({
      next: (result) => {
        this.produtoItems = result.produtos;
        this.itemsSimilar = result.similares;
        this.optionsProdutos = result.produtos
        
        console.log('Busca concluída:', {
          produtos: this.produtoItems.length,
          similares: this.itemsSimilar.length
        });
      },
      error: (err) => {
        console.error('Erro final na busca:', err);
        this.produtoItems = [];
        this.itemsSimilar = [];
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}